import * as React from "react";
import Utils from "../../helper/utils";
import GrupoEmailsDetalhe from "./detalhe";
import { useTranslation } from "react-i18next";

const GrupoEmailsPage = () => {
  const { t } = useTranslation();

  Utils.setDocumentTitle(t("pages.emailsGroups.titlePage"));

  return (
    <React.Fragment>
      <GrupoEmailsDetalhe />
    </React.Fragment>
  );
};

export default GrupoEmailsPage;
